import { Action } from 'redux'
import { combineEpics, Epic, ofType } from 'redux-observable'
import { filter, ignoreElements, tap } from 'rxjs'

import { isOpenFinRuntime } from '../../containers/OpenFin/helpers'
import { storeSelectedUser } from '../../helpers/selectedUser'
import { createStreamEpic } from '../../signalr/createStreamEpic'

import { UserSetSelectedUserAction } from './actions'
import { fetchUserDefinition } from './definition'

// Persist so popouts opened after a selection can seed it (see helpers/selectedUser).
const persistSelectedUserEpic: Epic<Action> = (action$) =>
  action$.pipe(
    ofType<UserSetSelectedUserAction>('users.setSelectedUser'),
    filter(() => isOpenFinRuntime()),
    tap((action: UserSetSelectedUserAction) =>
      storeSelectedUser(action.payload ?? 0)
    ),
    ignoreElements()
  )

export default combineEpics(
  createStreamEpic('users.fetch', fetchUserDefinition),
  persistSelectedUserEpic
)
